import { PosVendaProtocoloStatus, PosVendaProtocoloTipo } from '../../types/posVenda';
import { isTipoOrientarClienteCancelar1056 } from './posVendaTipoCatalog';

const FINAL: PosVendaProtocoloStatus[] = ['Concluido', 'Cancelado'];

/** Matriz MVP espelhando o spec (RF04). Gestor pode reabrir finais → EmAnalise. */
export function podeTransicionarStatus(
  de: PosVendaProtocoloStatus,
  para: PosVendaProtocoloStatus,
  opts?: { gestorReabre?: boolean }
): boolean {
  if (de === para) return false;

  if (opts?.gestorReabre && FINAL.includes(de) && para === 'EmAnalise') {
    return true;
  }

  if (FINAL.includes(de)) return false;

  if (para === 'Cancelado') return true;

  const map: Record<PosVendaProtocoloStatus, PosVendaProtocoloStatus[]> = {
    Aberto: ['EmAnalise', 'Cancelado'],
    EmAnalise: ['AguardandoCliente', 'AguardandoTerceiro', 'EmExecucao', 'Cancelado'],
    AguardandoCliente: ['EmAnalise', 'EmExecucao', 'Cancelado'],
    AguardandoTerceiro: ['EmAnalise', 'EmExecucao', 'Cancelado'],
    EmExecucao: ['AguardandoCliente', 'AguardandoTerceiro', 'Concluido', 'Cancelado'],
    Concluido: [],
    Cancelado: [],
  };

  return (map[de] ?? []).includes(para);
}

export function statusExigeResultado(para: PosVendaProtocoloStatus): boolean {
  return para === 'Concluido';
}

export function conclusaoExigeResultadoTexto(
  tipo: PosVendaProtocoloTipo,
  para: PosVendaProtocoloStatus
): boolean {
  return statusExigeResultado(para) && !isTipoOrientarClienteCancelar1056(tipo);
}

export function conclusaoExigeCancelamento1056Desfecho(
  tipo: PosVendaProtocoloTipo,
  para: PosVendaProtocoloStatus
): boolean {
  return statusExigeResultado(para) && isTipoOrientarClienteCancelar1056(tipo);
}

/** @deprecated usar avaliarBloqueioSuspensao (regras 14/10). */
export function suspensaoBloqueiaEmExecucao(
  _regraFidelidadeOk: boolean | null | undefined,
  _excecaoAprovadaEm: string | null | undefined
): boolean {
  return false;
}
